import { render, staticRenderFns } from "./OkReservation.vue?vue&type=template&id=fd20e472&"
import script from "./OkReservation.vue?vue&type=script&lang=ts&"
export * from "./OkReservation.vue?vue&type=script&lang=ts&"
import style0 from "./OkReservation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports